import { motion } from 'framer-motion';
import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const BackButton = ({ to, label = 'Back', fixed = true }) => {
  const navigate = useNavigate();

  return (
    <motion.button
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.3 }}
      onClick={() => to ? navigate(to) : navigate(-1)}
      className={`${fixed ? 'fixed top-6 left-6 z-50' : ''} group flex items-center gap-2 px-5 py-2.5 rounded-full overflow-hidden`}
      style={{
        background: 'rgba(0,0,0,0.5)',
        backdropFilter: 'blur(12px)',
        border: '1px solid rgba(168,85,247,0.15)',
        boxShadow: '0 0 15px rgba(168,85,247,0.05)',
      }}
      whileHover={{ scale: 1.05, boxShadow: '0 0 25px rgba(168,85,247,0.12)' }}
      whileTap={{ scale: 0.95 }}
      data-testid="back-button"
    >
      {/* Rotating conic border glow */}
      <motion.div
        className="absolute inset-[-1px] rounded-full pointer-events-none"
        style={{
          background: 'conic-gradient(from 0deg, transparent, rgba(168,85,247,0.25), rgba(34,197,94,0.15), transparent, rgba(168,85,247,0.2), transparent)',
          WebkitMask: 'radial-gradient(farthest-side, transparent calc(100% - 1.5px), black calc(100% - 1.5px))',
          mask: 'radial-gradient(farthest-side, transparent calc(100% - 1.5px), black calc(100% - 1.5px))',
        }}
        animate={{ rotate: [0, 360] }}
        transition={{ duration: 6, repeat: Infinity, ease: 'linear' }}
      />

      {/* Hover glow fill */}
      <div className="absolute inset-0 rounded-full bg-purple-500/0 group-hover:bg-purple-500/8 transition-all duration-500" />

      {/* Animated chevron */}
      <motion.div
        className="relative"
        animate={{ x: [0, -2, 0] }}
        transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
      >
        <ChevronLeft className="w-4 h-4" style={{ color: '#a855f7', filter: 'drop-shadow(0 0 4px rgba(168,85,247,0.4))' }} />
      </motion.div>

      {/* Label */}
      <span className="relative text-sm font-mono font-bold tracking-wider" style={{
        background: 'linear-gradient(90deg, #a855f7, #22c55e)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      }}>
        {label}
      </span>

      {/* Pulsing dot */}
      <motion.div
        className="relative w-1.5 h-1.5 rounded-full"
        style={{ background: '#22c55e', boxShadow: '0 0 6px rgba(34,197,94,0.5)' }}
        animate={{ scale: [1, 1.4, 1], opacity: [0.5, 1, 0.5] }}
        transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
      />
    </motion.button>
  );
};

export default BackButton;
